export default __webpack_public_path__ + "static/media/Screenshot 2021-04-30 113541sm.c5bd7fa0.png";